import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { ResourceSectionContainer } from "../shared/ResourceSectionContainer";
import { type ResourcesVariant, useResourceSections } from "./useResources";

const localeRoot = "community_onboarding.new_checklist.resources";

export interface ResourcesProps {
  variant?: ResourcesVariant;
}

export const Resources = ({ variant = "default" }: ResourcesProps) => {
  const resourceSections = useResourceSections({ variant });

  return (
    <div>
      <div className="mb-4">
        <Typography.LabelMd weight="semibold">
          {t(`${localeRoot}.title`)}
        </Typography.LabelMd>
      </div>
      <ResourceSectionContainer sections={resourceSections} />
    </div>
  );
};
